
  <div class="container">
    <div class="row" *ngIf="roteiros.length > 0">

      <div class="col-md-12 col-sm-12 scroll-table"> 
        <table class="table table-sm m-2">
          <thead>
            <tr>
              <th scope="col" >Roteiro</th>
              <th scope="col" >Motorista</th>
              <th scope="col" >Placa Veículo</th>
              <th scope="col" >Último contato</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let roteiro of roteiros" class="hover-pedido">
              <td>{{ roteiro.roteiro }} </td>
              <td>{{ roteiro.nome_motorista.trim() }}</td>
              <td>{{ roteiro.cod_veiculo }}</td>
              <td>{{ formataMinutos(roteiro.dataDiff) }}</td>
            </tr>
          </tbody>
        </table>  
      </div>
    </div>

  <div *ngIf="roteiros.length == 0" class="nao-relatada">
      <p>Nenhum motorista encontrado.</p>
  </div>
</div>